import { render, staticRenderFns } from "./PendingBlock.vue?vue&type=template&id=3d55c73f"
import script from "./PendingBlock.vue?vue&type=script&lang=js"
export * from "./PendingBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports